import styles from './Footer.module.css'
import { getImageUrl } from '../config'
import { trackCaseEvent, trackReportEvent } from '../utils/analytics'

type FooterMode = 'home' | 'cases-list' | 'reports-list' | 'case-detail'

interface FooterProps {
  isUnlocked?: boolean
  pdfUrl?: string
  mode?: FooterMode
  caseId?: number
  reportId?: number
  onBack?: () => void
}

const Footer = ({
  isUnlocked = false,
  pdfUrl,
  mode = 'home',
  caseId,
  reportId,
  onBack,
}: FooterProps) => {
  const handlePrimaryClick = () => {
    // Home, cases-list, reports-list pages - show 联系我们
    if (mode === 'home' || mode === 'cases-list' || mode === 'reports-list') {
      window.open('https://www.antom.com/cn/contact-us?portal_channel=Antom_Website_WeChat_Owned&utm_source=wechat&utm_medium=WeChat_content_hub_homepage', '_blank')
      return
    }

    // Case detail - direct download
    if (mode === 'case-detail') {
      if (isUnlocked && pdfUrl) {
        // Track download event
        if (caseId) {
          trackCaseEvent(caseId, 'download')
        } else if (reportId) {
          trackReportEvent(reportId, 'download')
        }
        window.open(getImageUrl(pdfUrl), '_blank')
      } else {
        document.getElementById('form-section')?.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  const getButtonText = () => {
    if (mode === 'home' || mode === 'cases-list' || mode === 'reports-list') {
      return '联系我们'
    }
    return isUnlocked ? '立即下载' : '立即解锁'
  }

  return (
    <div className={styles.footer}>
      {mode === 'home' ? (
        <div className={styles.logoContainer}>
          <img src="/images/footer-logo.png" alt="Antom" className={styles.logo} />
        </div>
      ) : (
        <div className={styles.backButton} onClick={onBack}>
          <svg viewBox="0 0 24 24" className={styles.backArrow}>
            <path d="M16 5l-5 7 5 7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className={styles.backText}>返回</span>
        </div>
      )}
      <button className={styles.contactButton} onClick={handlePrimaryClick}>
        <span className={styles.contactButtonText}>{getButtonText()}</span>
      </button>
      <div className={styles.decoration}></div>
    </div>
  )
}

export default Footer
